import FlightsRecommender from '../../../../components/containers/FlightsRecommender';
import preloadCustomProps from '../../../utils/preloads/preloadStaticContainerProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'flights-recommender',
  moduleId: 'em-cmp-lib-airmodules',
  containerConfig: {
    settings: {
      instance: FlightsRecommender
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
